import React from 'react';
import { Grid, IconButton, styled } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Colors } from 'library';

const StyledIconButton = styled(IconButton)({
    padding: 0,
    '&:focus': {
        outline: 'none',
    },
});

const CloseButton = ({ onClose, id }: { onClose: () => void; id?: string }) => {
    return (
        <Grid id={id ?? ''} container item justifyContent="flex-end" alignContent="flex-start" lg={12}>
            <StyledIconButton onClick={() => onClose()}>
                <CloseIcon style={{ color: Colors.primary }} />
            </StyledIconButton>
        </Grid>
    );
};

export default CloseButton;
